"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Get whether a user is a shine start or not
 */
const getIsShineStart = async ({ photon, uid, }) => {
    const { data: [shineStart], } = await photon.shineStarts.get('query', {
        params: { uid },
    });
    return !!shineStart && shineStart.status !== 'OPTED_OUT';
};
exports.default = getIsShineStart;
